
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.119.882a2.966 2.966 0 00-2.8-.8l-16 3.37a4.995 4.995 0 00-2.853 8.481l1.718 1.717a1 1 0 01.293.708v3.168a2.965 2.965 0 00.3 1.285l-.008.007.026.026A3 3 0 005.157 20.2l.026.026.007-.008a2.965 2.965 0 001.285.3h3.168a1 1 0 01.707.292l1.717 1.717A4.963 4.963 0 0015.587 24a5.049 5.049 0 001.605-.264 4.933 4.933 0 003.344-3.986l3.375-16.035a2.975 2.975 0 00-.792-2.833zM4.6 12.238l-1.719-1.717a2.94 2.94 0 01-.722-3.074 2.978 2.978 0 012.5-2.026L20.5 2.086 5.475 17.113v-2.755a2.978 2.978 0 00-.875-2.12zm13.971 7.17a3 3 0 01-5.089 1.712l-1.72-1.72a2.978 2.978 0 00-2.119-.878H6.888L21.915 3.5z"}})])
          )
        }
      }
    